import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke094aRequest, Sgke094aResponse, Sgke094aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke094aService {

  /**
   * コンストラクタ
   * @param {Sgke094aService} sgke094aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke094aService
   */
  constructor(
    private service: Sgke094aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 未精算関連承認検索API呼び出し
   * @param {Sgke094aRequest} request
   * @return {*}  {Observable<Sgke094aResponse>}
   * @memberof UsedSgke094aService
   */
  public doSgke094a(request: Sgke094aRequest): Observable<Sgke094aResponse> {

    return this.service.SGKE094APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE094A');
          return throwError(err.message);
        })
      );
  }
}
